// extracted by mini-css-extract-plugin
module.exports = {"authbox":"ChangePassword_authbox_2whNw","texth1":"ChangePassword_texth1_1AjTl"};